<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="documentDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pa-0 pb-2">{{
                    rowClicked.category
                }}</v-card-title>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Name:
                    </div>
                    <div>
                        {{ rowClicked.nameH }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2" v-if="rowClicked.hebName">
                    <div class="font-weight-medium mr-2">
                        Student Name:
                    </div>
                    <div>
                        {{ rowClicked.hebName }}
                    </div>
                </v-layout>
                <div
                    style="height: 450px; overflow-y: auto;"
                    class="mt-3"
                    v-if="rowClicked.fileURL && numPages && isPdf()"
                >
                    <!-- <pdf
                        style="max-height: 450px !important; width: 100%;"
                        :src="rowClicked.fileURL"
                    ></pdf> -->
                    <pdf
                        v-for="i in numPages"
                        :key="i"
                        :src="src"
                        :page="i"
                        style=" width: 100%;"
                    ></pdf>
                </div>
                <div
                    class="mt-3"
                    v-if="rowClicked.fileURL && isImage()"
                    style="height: 450px; overflow-y: auto;"
                >
                    <img
                        :src="rowClicked.fileURL"
                        style="max-height: 950px !important;"
                    />
                </div>
                <v-layout row class="pa-0 my-3">
                    <v-select
                        outline
                        style="width: 250px;"
                        label="Status"
                        class="mt-3 mr-3 mb-0"
                        v-model="rowClicked.status"
                        :items="['APPROVED', 'UPLOADED', 'REJECTED']"
                        ref="status"
                        hide-details
                    >
                    </v-select>
                    <v-select
                        outline
                        style="width: 250px;"
                        label="Category"
                        class="mt-3 mb-0"
                        v-model="rowClicked.category"
                        :items="[
                            'HISCYVIS',
                            'INSURANCE CARD',
                            'HEALTH FORM',
                            ' LUNCH',
                        ]"
                        ref="category"
                        hide-details
                    >
                    </v-select>
                </v-layout>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeDocumentDialog"
                        >Close</v-btn
                    >
                    <v-btn
                        outline
                        :disabled="processing"
                        color="success"
                        @click="copy"
                        >Copy Document</v-btn
                    >
                    <v-btn :loading="processing" color="success" @click="save"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="scheduleDownloadDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Schedule Download</v-card-title>
                <v-text-field
                    ref="notificationEmail"
                    v-model="notificationEmail"
                    label="Notification Email"
                    class="px-3"
                    :rules="emailRules"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="scheduleDownloadDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="scheduleDownload"
                    >
                        download
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatCurrency } from "../../utils/helpers.js";
import pdf from "vue-pdf";
import moment from "moment";

export default {
    components: {
        pdf,
    },
    data: () => ({
        title: "Documents",
        documentDialog: false,
        rowClicked: "",
        processing: false,

        actions: [],

        regID: "",
        url: "",
        numPages: undefined,
        src: "",
        currentRegID: "",

        notificationEmail: "",
        scheduleDownloadDialog: false,

        emailRules: [
            (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
        ],

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "UPLOADED":
                            return "mdi-file-upload";
                        case "PENDING REVIEW":
                            return "mdi-flag-outline";
                        case "REJECTED":
                            return "mdi-close-circle";
                        case "SENT TO VAAD MISHMERES":
                        case "SENT TO VAAD-MISHMERES":
                            return "mdi-email";
                        case "IMPORTED":
                        case "IMPORTED-SD":
                        case "COMPLETED":
                        case "APPROVED":
                            return "mdi-file-check";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "UPLOADED":
                            return "#aeb8bf";
                        case "PENDING REVIEW":
                            return "#fdb400";
                        case "REJECTED":
                            return "#f35123";
                        case "SENT TO VAAD MISHMERES":
                            return "info";
                        case "IMPORTED":
                        case "IMPORTED-SD":
                        case "COMPLETED":
                        case "APPROVED":
                            return "success";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameH",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "YKCAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "studentID",
                label: "Student ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "hebName",
                label: "Student Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "category",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "File Name",
            //     field: "fileURL",
            //     format: "",
            //     template: "link-action-cell-template",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            //     showLink: (row) => {
            //         return true;
            //         //return row.status == "UPLOADED";
            //     },
            // },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Uploaded By",
                field: "uploadedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registration Status",
                field: "registrationStatus",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Code 2",
                field: "code2",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        // this.columns.find((c) => c.field == "fileURL").linkAction = (
        //     document
        // ) => {
        //     window.open(document.fileURL);
        // };

        this.actions.push({
            text: "Download Documents",
            action: this.openScheduleDownloadDialog,
            showOnSelection: true,
        });
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "YKCDocuments?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
            this.currentRegID = this.regID;
        },
        async getTerms() {
            return await this.$http.get("api/yk/getRegTerms");
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            const loadingTask = pdf.createLoadingTask(this.rowClicked.fileURL);

            this.src = loadingTask;

            this.src.promise.then((pdf) => {
                this.numPages = pdf.numPages;
            });

            this.documentDialog = true;
        },
        isPdf() {
            if (!this.rowClicked) return false;

            return ["pdf", "PDF"].includes(
                this.rowClicked.fileURL.split(".").pop(),
            );
        },
        isImage() {
            if (!this.rowClicked) return false;

            return ["jpg", "jpeg", "png", "tif", "JPG", "JPEG"].includes(
                this.rowClicked.fileURL.split(".").pop(),
            );
        },
        closeDocumentDialog() {
            this.documentDialog = false;
            this.rowClicked = "";
        },
        async copy() {
            try {
                if (this.rowClicked.regID == this.currentRegID) {
                    return this.$notify({
                        text: "Can't copy document from this year.",
                        group: "notification",
                        type: "error",
                    });
                }

                this.processing = true;

                await this.$http.post("api/YKCDocuments/CopyDocument", {
                    documentID: this.rowClicked.documentID,
                    user: this.$store.state.authentication.user,
                    regID: this.currentRegID,
                });

                this.processing = false;
                this.documentDialog = false;

                this.$notify({
                    text: "Document copied",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post("api/YKCDocuments/save", this.rowClicked);

                this.processing = false;
                this.documentDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "YKCDocuments?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        openScheduleDownloadDialog() {
            this.scheduleDownloadDialog = true;
        },
        async scheduleDownload() {
            if (!this.$refs.notificationEmail.validate(true)) return;

            let documents = this.$refs.grid.getSelectedRowsData();

            const columnSort = this.columns.find((c) => {
                const sort = this.$refs.grid.grid.columnOption(
                    c.field,
                    "sortOrder",
                );

                if (!sort) return false;

                return true;
            });

            if (columnSort) {
                const sortOrder = this.$refs.grid.grid.columnOption(
                    columnSort.field,
                    "sortOrder",
                );

                documents = documents.sort((a, b) => {
                    if (sortOrder == "desc") {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return 1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return -1;
                        }
                        return 0;
                    } else {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return -1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return 1;
                        }
                        return 0;
                    }
                });
            }

            if (!documents.length) {
                this.$notify({
                    group: "notification",
                    text: "No Documents Selected.",
                    type: "warning",
                });

                return;
            }

            this.requestID = Math.floor(Math.random() * 10000000);

            try {
                this.processing = true;

                const response = await this.$http({
                    url: "api/yk/scheduleFileDownload",
                    method: "POST",
                    data: {
                        documents: documents.map((s) => s.documentID),
                        students: documents.map((s) => s.studentID),
                        classList: this.createClassListHtml(documents),
                        //requestID: this.requestID,
                        email: this.notificationEmail,
                        type: "YKC_DOCUMENTS",
                        user: this.$store.state.authentication.user,
                        date: moment().format("YYYY-MM-DD HH:mm:ss"),
                    },
                    responseType: "blob",
                });

                this.$notify({
                    group: "notification",
                    text: this.notificationEmail
                        ? "You will be notified once the file is ready to download"
                        : "Check back later at the file downloas page to check for the status of your file",
                    type: "success",
                });
                this.scheduleDownloadDialog = false;
            } catch (e) {
                this.processing = false;
            } finally {
                this.processing = false;

                this.requestID = "";
            }
        },
        createClassListHtml(documents) {
            let html = `<head>
                        <style>
                        table {
                          font-family: arial, sans-serif;
                          border-collapse: collapse;
                          width: 100%;
                        }

                        .nice-text {
                            font-family: arial, sans-serif;
                        }

                        td, th {
                          border: 1px solid #dddddd;
                          text-align: left;
                          padding: 8px;
                        }

                        tr:nth-child(even) {
                          background-color: #dddddd;
                        }

                        .right-align {
                text-align: right;
            }
                        </style>
                        </head>`;

            html += `<p class="nice-text right-align">${moment().format(
                "LLL",
            )}</p>`;

            html += `<table>
                            <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th class="right-align">Hebrew Name</th>
                            <th class="right-align">Father</th>
                          `;

            html += `<th>Grade</th><th>Branch</th>`;

            html += "</tr>";

            documents
                .map((student, index) => {
                    let data = {
                        number: index + 1,
                        name: student.engName,
                        hebName: student.hebName,
                        fatherH: student.nameH,
                    };

                    data.class = student.class;
                    data.branch = student.branch;

                    return data;
                })
                .forEach((student) => {
                    html += `<tr>`;

                    Object.entries(student).forEach((v) => {
                        const field = v[0];
                        const value = v[1];

                        html += ["hebName", "fatherH"].includes(field)
                            ? `<td class="right-align">${value}</td>`
                            : `<td>${value}</td>`;
                    });

                    html += `</tr>`;
                });

            html += `</table>`;

            return html;
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
